import React from 'react';
import 'antd/dist/antd.min.css';
import { Text } from 'shared/components/Text';
import { notification } from 'antd';
import { NotificationMessages } from 'shared/enums';
import Info from 'shared/components/Icons/Info';
import classes from './styles.module.scss';
import { CloseIcon } from 'shared/components/Icons';

type TMessage = {
  type?: string;
  title?: string;
  message?: string;
  withActionButton?: boolean;
};

export const openNotificationMessage = (props: TMessage) => {
  const {
    type = NotificationMessages.Information,
    title = 'Notification',
    message = '',
    withActionButton = false
  } = props;
  if (type === NotificationMessages.Error)
    notification.open({
      message: (
        <div style={{ paddingTop: '4px', paddingLeft: '-200px' }}>
          <Text type="sf-body-emphasized" color="grey-primary">
            {title}
          </Text>
        </div>
      ),
      top: 40,
      description: (
        <div style={{ width: '200px' }}>
          <Text type="sf-body" color="grey-second">
            {message}
          </Text>
        </div>
      ),
      closeIcon: <CloseIcon width={13} height={13} />,
      style: {
        right: '15px',
        width: '292px',
        minHeight: '50px',
        borderLeft: '4px solid #DF1B1B',
        borderRadius: '4px',
        padding: '16px',
        paddingLeft: '10px'
      },
      className: classes.container,
      duration: 5,
      icon: (
        <span>
          <Info color="#DF1B1B" />
        </span>
      ),
      btn: withActionButton && (
        <Text
          className={classes.action_section}
          type="sf-body-medium"
          color="blue-dark"
        >
          <a
            style={{
              marginTop: '0px',
              marginRight: '197px',
              color: '#0D7EB7',
              letterSpacing: '-0.154px'
            }}
            href="#"
          >
            Action
          </a>
        </Text>
      )
    });
  if (type === NotificationMessages.Success)
    notification.open({
      message: (
        <div style={{ paddingTop: '4px', paddingLeft: '-200px' }}>
          <Text type="sf-body-emphasized" color="grey-primary">
            {title}
          </Text>
        </div>
      ),
      top: 40,
      description: (
        <div style={{ width: '200px' }}>
          <Text type="sf-body" color="grey-second">
            {message}
          </Text>
        </div>
      ),
      closeIcon: <CloseIcon width={13} height={13} />,
      style: {
        right: '15px',
        width: '292px',
        minHeight: '50px',
        borderLeft: '4px solid #228403',
        borderRadius: '4px',
        padding: '16px',
        paddingLeft: '10px'
      },
      className: classes.container,
      duration: 5,
      icon: (
        <span>
          <Info color="#228403" />
        </span>
      ),
      btn: withActionButton && (
        <Text
          className={classes.action_section}
          type="sf-body-medium"
          color="blue-dark"
        >
          <a
            style={{
              marginTop: '0px',
              marginRight: '197px',
              color: '#0D7EB7',
              letterSpacing: '-0.154px'
            }}
            href="#"
          >
            Action
          </a>
        </Text>
      )
    });
  if (type === NotificationMessages.Information)
    notification.open({
      message: (
        <div style={{ paddingTop: '4px', paddingLeft: '-200px' }}>
          <Text type="sf-body-emphasized" color="grey-primary">
            {title}
          </Text>
        </div>
      ),
      top: 40,
      description: (
        <div style={{ width: '200px' }}>
          <Text type="sf-body" color="grey-second">
            {message}
          </Text>
        </div>
      ),
      closeIcon: <CloseIcon width={13} height={13} />,
      style: {
        right: '15px',
        width: '292px',
        minHeight: '50px',
        borderLeft: '4px solid #3AA5DC',
        borderRadius: '4px',
        padding: '16px',
        paddingLeft: '10px'
      },
      className: classes.container,
      duration: 5,
      icon: (
        <span>
          <Info color="#3AA5DC" />
        </span>
      ),
      btn: withActionButton && (
        <Text
          className={classes.action_section}
          type="sf-body-medium"
          color="blue-dark"
        >
          <a
            style={{
              marginTop: '0px',
              marginRight: '197px',
              color: '#0D7EB7',
              letterSpacing: '-0.154px'
            }}
            href="#"
          >
            Action
          </a>
        </Text>
      )
    });
};
